import { render, staticRenderFns } from "./ModalSettingsSave.vue?vue&type=template&id=3140e894&scoped=true"
import script from "./ModalSettingsSave.vue?vue&type=script&lang=js"
export * from "./ModalSettingsSave.vue?vue&type=script&lang=js"
import style0 from "./ModalSettingsSave.vue?vue&type=style&index=0&id=3140e894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3140e894",
  null
  
)

export default component.exports